import {h} from 'ui/Framework';

export default h('svg', {
  width: '60',
  height: '32',
  viewBox: '0 0 60 32',
  xmlns: 'http://www.w3.org/2000/svg'
}, [
  h('g', {
    fillRule: 'nonzero',
    fill: 'none'
  }, [
    h('ellipse', {
      fill: '#E4F1FD',
      cx: '30',
      cy: '16',
      rx: '30',
      ry: '16'
    }),
    h('ellipse', {
      fill: '#E4F1FD',
      cx: '30',
      cy: '15.5',
      rx: '29',
      ry: '14.5'
    }),
    h('path', {
      d: 'M35.319 20.27l1.426-7.247c.327-1.638.046-2.861-.795-3.623-.818-.738-2.22-1.108-4.277-1.108h-2.477l.701-3.6a.478.478 0 0 0-.093-.392.423.423 0 0 0-.35-.162H26.04a.476.476 0 0 0-.467.37l-1.52 7.684c-.14-.877-.466-1.615-1.027-2.215-1.005-1.13-2.571-1.708-4.698-1.708h-6.567a.476.476 0 0 0-.467.37l-3.061 15.6a.478.478 0 0 0 .093.392c.094.115.21.161.35.161h3.436c.234 0 .42-.161.467-.369l.748-3.761h2.548c1.332 0 2.477-.139 3.341-.416.912-.3 1.73-.784 2.454-1.454a7.47 7.47 0 0 0 1.45-1.777l-.608 3.116a.478.478 0 0 0 .093.392c.093.115.21.162.35.162h3.412c.234 0 .421-.162.468-.37l1.682-8.538h2.337c1.005 0 1.286.185 1.38.277.07.07.21.346.046 1.2l-1.355 6.9a.478.478 0 0 0 .093.392c.094.116.21.162.35.162h3.506c.21-.07.397-.231.444-.439zm-15.798-6c-.21 1.084-.607 1.868-1.192 2.307-.584.438-1.542.67-2.804.67h-1.519l1.098-5.585h1.963c1.45 0 2.034.3 2.267.553.304.37.374 1.085.187 2.054zm30.38-4.293c-1.004-1.13-2.57-1.708-4.697-1.708h-6.613a.476.476 0 0 0-.468.37l-3.061 15.576a.478.478 0 0 0 .093.393c.094.115.21.161.351.161h3.435c.234 0 .421-.161.468-.369l.748-3.762h2.547c1.332 0 2.477-.138 3.342-.415.911-.3 1.729-.785 2.453-1.454a7.447 7.447 0 0 0 1.496-1.846c.374-.67.654-1.408.818-2.215.397-2.008.094-3.577-.911-4.731zm-3.575 4.292c-.21 1.085-.608 1.87-1.192 2.308-.584.438-1.542.67-2.804.67h-1.52l1.1-5.585h1.962c1.45 0 2.033.3 2.267.553.327.37.397 1.085.187 2.054z',
      fill: '#FFF'
    }),
    h('path', {
      d: 'M17.405 11.698c1.315 0 2.184.234 2.63.726.446.492.54 1.311.305 2.482-.235 1.218-.704 2.108-1.385 2.623-.681.515-1.714.773-3.1.773h-2.089l1.291-6.604h2.348zM9 25h3.451l.822-4.192h2.958c1.315 0 2.372-.14 3.217-.422a6.17 6.17 0 0 0 2.3-1.381 7.03 7.03 0 0 0 1.41-1.757c.352-.632.61-1.335.75-2.107.376-1.874.095-3.326-.821-4.38-.916-1.054-2.371-1.569-4.367-1.569h-6.644L9 25zM26.444 5h3.428l-.821 4.192h3.052c1.925 0 3.24.328 3.968 1.007.727.68.939 1.757.657 3.255l-1.432 7.354H31.82l1.362-7.002c.164-.797.094-1.335-.165-1.616-.258-.281-.845-.445-1.714-.445h-2.747l-1.76 9.063h-3.428L26.444 5zm17.89 6.698c1.316 0 2.184.234 2.63.726.447.492.54 1.311.306 2.482-.235 1.218-.705 2.108-1.385 2.623-.681.515-1.714.773-3.1.773h-2.09l1.292-6.604h2.348zM35.93 25h3.451l.822-4.192h2.958c1.315 0 2.371-.14 3.217-.422a6.17 6.17 0 0 0 2.3-1.381 7.03 7.03 0 0 0 1.41-1.757c.351-.632.61-1.335.75-2.107.376-1.874.094-3.326-.821-4.38-.916-1.054-2.372-1.569-4.367-1.569h-6.645L35.93 25z',
      fill: '#F7F9FA'
    })
  ])
]);



// WEBPACK FOOTER //
// ./src/javascripts/svg/php.es6.js